export const modalKindOptionsEnum = Object.freeze({
	delete: "delete",
	activate: "activate",
	deactivate: "deactivate"
});
export default modalKindOptionsEnum;